import { Avatar, Box, Stack } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Color, FontStyle } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn, prettyDateShort } from "../../utils/utils";
import { selectChat } from "../../utils/actionUtils";
import * as apiService from "../../service/ApiService";

const styles = {
  mainText: {
    // fontWeight: "bold",
    fontSize: "16px",
    color: "#000",
  },
  subText: {
    fontSize: "12px",
    // color: Color.secondaryTextGray,
  },
};

const TempAvatar = ({ name, userId, size = "48px", fontSize = "18px" }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const loggedIn = isLoggedIn(auth);
  const recipientProfilePics = useSelector(
    (state) => state.messages.recipientProfilePics
  );
  useEffect(() => {
    if (loggedIn && recipientProfilePics[userId] === undefined) {
      console.log("dispatching get recipient profile pic", userId);
      apiService.applicantgetRecruiterProfilePic(
        dispatch,
        null,
        {
          ...auth.accountData,
          recruiterId: userId,
        },
        {}
      );
    }
  }, [loggedIn, userId]);
  return (
    <Stack
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        width: size,
        minWidth: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "#ddd",
        color: "#fff",
        fontSize: fontSize,
        fontWeight: "bold",
      }}>
      {recipientProfilePics[userId] ? (
        <Avatar
          alt={name}
          src={recipientProfilePics[userId].url}
          sx={{
            width: size,
            height: size,
            borderRadius: "50%",
          }}
        />
      ) : name.length > 0 ? (
        name[0]
      ) : null}
    </Stack>
  );
};

const readIconSize = "12px";
const MaybeReadIcon = ({ recipient, message, maxWidth = "150px" }) => {
  const { userId, dt, text, senderIsApplicant, seen } = message;
  //   return (
  //     <Box
  //       sx={{
  //         height: readIconSize,
  //         width: readIconSize,
  //         borderRadius: "50%",
  //         backgroundColor: Color.primary,
  //       }}
  //     />
  //   );
  if ((senderIsApplicant && !seen) || (!senderIsApplicant && seen)) {
    // user sent message&not seen, or recruiter sent message&seen
    return (
      <Box
        sx={{
          height: readIconSize,
          width: readIconSize,
        }}
      />
    );
  }
  if (!senderIsApplicant && !seen) {
    // new message
    return (
      <Box
        sx={{
          height: readIconSize,
          width: readIconSize,
          borderRadius: "50%",
          color: Color.primary,
        }}
      />
    );
  }
  if (senderIsApplicant && seen) {
    // message is read by recruiter
    return (
      <TempAvatar
        name={recipient.firstName}
        userId={recipient.userId}
        size={readIconSize}
        fontSize="7px"
      />
    );
  }
  return null; // never reached
};
const MsgPreview = ({ recipient, message, maxWidth = "150px" }) => {
  const { userId, dt, text, senderIsApplicant, applicationId } = message;
  return (
    <Box
      sx={{
        ...styles.subText,
        display: "inline-block",
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        width: maxWidth,
        maxWidth: maxWidth,
      }}>
      {!senderIsApplicant ? recipient.firstName : "You"}: {text}
    </Box>
  );
};
const SidebarChatPreview = ({ chat }) => {
  const dispatch = useDispatch();
  const { recipient, history } = chat;
  const userNotRead = !history.at(-1).senderIsApplicant && !history.at(-1).seen;
  const [compareDate, setCompareDate] = useState(new Date());
  useEffect(() => {
    setCompareDate(new Date());
  }, [history]);
  //   const userNotRead = true;
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      onClick={() => {
        selectChat(dispatch, chat);
      }}
      sx={{
        width: "100%",
        // px: 1,
        py: 1,
        cursor: "pointer",
        borderRadius: "5px",
        backgroundColor: userNotRead ? "#fff" : "transparent",
        fontWeight: userNotRead ? "bold" : "normal",
        color: userNotRead ? "#000" : Color.secondaryTextGray,
        "&:hover": {
          backgroundColor: "#eee",
        },
      }}>
      <TempAvatar
        name={chat.recipient.firstName}
        userId={chat.recipient.userId}
      />
      <Stack
        direction="column"
        spacing="6px"
        sx={{
          width: "180px",
        }}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center">
          <Box
            sx={
              styles.mainText
            }>{`${chat.recipient.firstName} ${chat.recipient.lastName}`}</Box>
          <MaybeReadIcon recipient={recipient} message={history.at(-1)} />
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center">
          <MsgPreview recipient={recipient} message={history.at(-1)} />
          <Box sx={styles.subText}>
            {prettyDateShort(chat.history.at(-1).dt, compareDate)}
          </Box>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SidebarChatPreview;
